module.exports = __webpack_public_path__ + "img/ar30_samurai02_shop.9140cc4f.png";